import React from "react";
import Table from "./Table";

/**
 * نمایش خودکار: در دسکتاپ جدول، در موبایل کارت
 *
 * props:
 *   columns: [{ key, label, render?, num?, hideOnMobile? }]
 *   rows, loading, empty
 *   actions?: (row) => JSX  → در موبایل به‌صورت دکمه‌های پایین کارت نمایش داده می‌شود
 *   mobileTitle?: (row) => JSX  → عنوان کارت در موبایل (پیش‌فرض: اولین ستون غیر مخفی)
 *   mobileMeta?:  (row) => [{ icon, label, value, full? }]  → ردیف‌های داخل کارت
 *   mobileBadge?: (row) => JSX  → بج گوشه‌ی عنوان
 *   onRowClick?: (row) => void
 */
export default function ResponsiveList({
  columns, rows, loading, empty,
  actions, mobileTitle, mobileMeta, mobileBadge, onRowClick,
  rowClass
}) {
  const titleCol = mobileTitle
    ? null
    : columns.find((c) => !c.hideOnMobile);

  const getTitle = (r) =>
    mobileTitle ? mobileTitle(r) : (titleCol?.render ? titleCol.render(r) : r[titleCol?.key] ?? "—");

  return (
    <div className="card">
      {/* دسکتاپ */}
      <div className="rl-desktop">
        <Table
          columns={columns}
          rows={rows}
          loading={loading}
          empty={empty}
          actions={actions}
          rowClass={rowClass} 
        />
      </div>

      {/* موبایل */}
      <div className="rl-mobile">
        {loading ? (
          <div className="empty"><div className="spinner" style={{ margin: "0 auto" }} /></div>
        ) : rows.length === 0 ? (
          <div className="empty"><i className="fa-regular fa-folder-open" />{empty || "موردی ثبت نشده است"}</div>
        ) : (
          rows.map((r) => {
            const meta = mobileMeta ? mobileMeta(r) : [];
            return (
              <div
              className={`rl-card ${rowClass ? rowClass(r) : ""}`}
                key={r.id ?? Math.random()}
                onClick={onRowClick ? () => onRowClick(r) : undefined}
                style={onRowClick ? { cursor: "pointer" } : undefined}
                
              >
                <div className="rl-head">
                  <div className="rl-title">{getTitle(r)}</div>
                  {mobileBadge && <div className="rl-badge">{mobileBadge(r)}</div>}
                </div>

                {meta.map((m, i) => (
                  <div className="rl-row" key={i} style={m.full ? { alignItems: "flex-start" } : undefined}>
                    {m.icon && <i className={m.icon} style={{ marginTop: m.full ? 4 : 0 }} />}
                    {m.label && <span className="rl-label">{m.label}:</span>}
                    <span className="rl-value">{m.value}</span>
                  </div>
                ))}

                {actions && <div className="rl-actions">{actions(r)}</div>}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}